import React from 'react';
import { Shield, Users, Brain, Zap, CheckCircle } from 'lucide-react';

const WhyGradVikalp = () => {
  const features = [
    {
      icon: Shield,
      title: 'Verified Reviews',
      description: 'All reviews are verified from real students and alumni',
      color: 'text-success'
    },
    {
      icon: Users,
      title: 'Real Students',
      description: 'Connect directly with current students and graduates',
      color: 'text-primary'
    },
    {
      icon: Brain,
      title: 'Personalized Tools',
      description: 'AI-powered recommendations tailored to your profile',
      color: 'text-info'
    },
    {
      icon: Zap,
      title: 'Updated Info',
      description: 'Real-time updates on cutoffs, admissions, and deadlines',
      color: 'text-warning'
    }
  ];

  const testimonials = [
    {
      // name: 'Sneha Patel',
      // text: 'Grad Vikalp helped me find the perfect engineering college. The student connections were invaluable!',
      // college: 'NIT Trichy'
    },
    { 
      // name: 'Rohan Kumar',
      // text: 'The  Your Personalized college list saved me so much time. Got into my dream medical college!',
      // college: 'JIPMER'
    }
  ];

  return (
    <section className="py-3 py-md-5 bg-white">
      <div className="container">
        <div className="text-center mb-4 mb-md-5 px-2">
          <h2 className="h1 fw-bold text-dark mb-3" style={{ fontSize: 'clamp(1.75rem, 5vw, 2.5rem)' }}>
            Why Choose Grad Vikalp?
          </h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: '600px', fontSize: 'clamp(1rem, 3vw, 1.25rem)' }}>
            Your trusted partner in making the right college choice
          </p>
        </div>

        <div className="row g-2 g-md-4 mb-3 mb-md-5 px-2 px-md-0 features-mobile-grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="col-6 col-md-3">
                <div className="text-center">
                  <div className={`feature-icon bg-light mb-1 mb-md-3 mx-auto`} style={{ width: 'clamp(2rem, 6vw, 4rem)', height: 'clamp(2rem, 6vw, 4rem)' }}>
                    <Icon className={feature.color} size={24} />
                  </div>
                  <h5 className="fw-bold text-dark mb-1 mb-md-2" style={{ fontSize: 'clamp(0.7rem, 2.5vw, 1.25rem)', lineHeight: '1.1' }}>
                    {feature.title}
                  </h5>
                  <p className="text-muted mb-0" style={{ fontSize: 'clamp(0.6rem, 2vw, 1rem)', lineHeight: '1.2' }}>
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Trust Indicators */}
        {/* <div className="bg-light rounded-4 p-5 mb-5">
          <div className="row g-4 text-center">
            <div className="col-lg-3 col-6">
              <div className="stats-number text-primary">000+</div>
              <div className="text-muted">Students Helped</div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="stats-number text-success">000+</div>
              <div className="text-muted">College Reviews</div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="stats-number text-info">000+</div>
              <div className="text-muted">Student Mentors</div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="stats-number text-warning">95%</div>
              <div className="text-muted">Success Rate</div>
            </div>
          </div>
        </div> */} 
  
        {/* Testimonials */}
        <div className="row g-4">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="col-12 col-md-6">
              <div className="testimonial-card">
                <div className="d-flex align-items-start gap-3">
                  <CheckCircle className="text-success flex-shrink-0 mt-1" size={20} />
                  <div>
                    <p className="text-muted mb-3 fst-italic" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}>
                      "{testimonial.text}"
                    </p>
                    <div className="fw-semibold text-dark" style={{ fontSize: 'clamp(0.9rem, 3vw, 1rem)' }}>
                      {testimonial.name}
                    </div>
                    <div className="small text-muted" style={{ fontSize: 'clamp(0.8rem, 2.5vw, 0.875rem)' }}>
                      {testimonial.college}
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyGradVikalp;